import { render, staticRenderFns } from "./JudgesCasesCount.vue?vue&type=template&id=7741d0b5"
import script from "./JudgesCasesCount.vue?vue&type=script&lang=js"
export * from "./JudgesCasesCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports